module.exports = __webpack_public_path__ + "img/gift_bg.9771f75.png";